export const configureTaxRates = (values) => {
  const { rate, name } = values;
  return {
    rate: rate / 100,
    name: name,
    origin: "adelie",
    isActive: true,
  };
};
